import { Box, styled } from "@mui/material";

export const StyledArtTable = styled(Box)(({ theme }) => ({
  width: "95%",
  ".filterBar": {
    width: "50%",
    margin: "auto",
    paddingBlock: "2rem",
  },
  ".table": {
    maxHeight: "40rem",
    position: "relative",
    overflow: 'scroll',
    ".header": {
      display: "flex",
      background: theme.color.main,
      borderRadius: "10px 10px 0 0",
      color: theme.color.background,
      paddingBlock: ".5rem",
      position: "sticky",
      top: "0",
      width: "100%",
      zIndex: "60",
    },
    ".content": {
      borderRadius: "0 0 10px 10px",
      paddingTop: "0",
      "& > *:nth-child(odd)": {
        background: theme.contrast.lighter,
      },
      ".artItem": {
        display: "flex",
        alignItems: "center",
        "& .MuiInputBase-root": {
          width: "90%",
          border: `2px solid ${theme.color.dark}`,
          flex: "1 1 0",
          color: theme.color?.dark || theme.palette.text.primary,
        },
        "& .MuiInputBase-input": {
          padding: ".25rem !important",
          width: "100%",
        },
        "& .MuiInput-underline:before, & .MuiInput-underline:after": {
          display: "none",
        },
      },
    },
    ".id": {
      width: "2%",
      paddingLeft: "1rem",
    },
    ".title": {
      width: "25%",
    },
    ".description": {
      width: "25%",
    },
    ".type": {
      width: "8%",
    },
    ".sellstate": {
      width: "20%",
    },
    ".vieuws": {
      width: "5%",
    },
    ".date": {
      width: "5%",
    },
    ".actions": {
      width: "10%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    h4: {
      fontWeight: "bold",
    },
  },
}));
